exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".omni-basic-search[data-v-164421f2]{margin:5px;height:30px;min-height:30px;display:flex;box-shadow:0 4px 8px 0 rgba(0,0,0,.2)}#basic-search[data-v-164421f2]{width:100%;height:100%}", ""]);

// exports
